import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SabreText } from '@shared/components/sabre-text-dialog/models/sabre-text';
import { AlertService } from '@shared/services/alert/alert.service';
import { HiTextService } from './hi-text.service';
import { RequestState } from '@shared/models/request-state';
import { ActivityResponse } from '@calendar/models/response/activity.response';

@Injectable({
  providedIn: 'root',
})
export class HiTextStore {
  refreshFn = (type: 'hi1' | 'hi2') => this.refreshActivity(type);

  constructor(
    private hiTextService: HiTextService,
    private alertService: AlertService
  ) {}

  getActivity(type: 'hi1' | 'hi2'): Observable<RequestState<SabreText>> {
    return this.hiTextService.getActivity(type).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      })
    );
  }

  refreshActivity(type: 'hi1' | 'hi2'): Observable<RequestState<SabreText>> {
    return this.hiTextService.refreshActivity(type).pipe(
      map((requestState) => {
        return this.mapResponse(requestState);
      })
    );
  }

  mapResponse(
    requestState: RequestState<ActivityResponse>
  ): RequestState<SabreText> {
    if (requestState.hasError) {
      this.showErrorAlert();
    }

    // If no response to process, pass on state.
    if (!requestState.response) {
      return requestState.into<SabreText>();
    }

    return requestState.into<SabreText>(
      new SabreText(requestState.response.raw, requestState.response.timestamp)
    );
  }

  showErrorAlert(): void {
    this.alertService.setAlert({
      type: 'error',
      message: 'Sabre request failed.',
    });
  }
}
